export let data = {
  title: "Input Pemeriksaan Ophthalmic",
  backBtn: "/ugd",
  actionBtn: [],
  breadcrumb: [
    { title: "UGD", link: "/ugd" },
    { title: "Input Pemeriksaan Ophthalmic", active: true }
  ]
};
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" }
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)"
        },
        {
          colnum: 7,
          icon: "",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)"
        }
      ]
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 \nPerumnas Depok I Kel. Depok Jaya, \nKec. Pancoran Mas Depok, Jawa Barat"
        }
      ]
    }
  ]
};

export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    columns: [
      {
        label: "No. Rawat",
        content: "2020/04/16/000001",
        icon: "apps",
        colwidth: 6
      },
      {
        label: "Unit",
        content: "MAT | Poliklinik Mata",
        icon: "apps",
        colwidth: 6
      }
    ]
  }
];
export let detailRightTop = [
  {
    label: "Dokter yang Dituju",
    content: "D00000026  |   dr. Azizah Masthura",
    icon: "apps"
  }
];
export let today = new Date();
import { getTime } from './helper.js';
export let time = getTime(today.getHours(), today.getMinutes());
export let upperForm = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal Periksa",
        type: "date",
        placeholder: "Pilih tanggal periksa",
        name: "tgl_periksa",
        value: today,
        mandatory: true,
        additional: "",
        colwidth: "3"
      },
      {
        label: "Jam",
        type: "time",
        placeholder: "jj:mm",
        name: "jam_periksa",
        value: time,
        mandatory: true,
        additional: "",
        colwidth: "2"
      },
      {
        label: "Perawat Pemeriksa 1",
        type: "select",
        placeholder: "Perawat Pemeriksa 1",
        name: "id_petugas",
        value: "",
        mandatory: true,
        multiple: false,
        options: [
          {
            label: "P0000026 | Anggriani Ginting",
            value: "P0000026"
          }
        ],
        additional: "",
        colwidth: 3
      },
      {
        label: "Perawat Pemeriksa 2",
        type: "select",
        placeholder: "Perawat Pemeriksa 2",
        name: "id_petugas_2",
        value: "",
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "P0000026 | Anggriani Ginting",
            value: "P0000026"
          }
        ],
        additional: "",
        colwidth: 3
      }
    ]
  }
];
export let formKeluhan = [
  {
    colnum: 1,
    columns: [
      {
        label: "Keluhan Pasien",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "keluhan",
        value: "",
        mandatory: true,
        colwidth: 10
      }
    ]
  },
  {
    colnum: 2,
    class: '',
    flexStart: true,
    columns: [
      {
        label: "Hasil USG",
        type: "image",
        placeholder: "Upload Hasil USG",
        name: "foto_usg[0]",
        value: '',
        mandatory: true,
        additional: "File berekstensi .jpg,.jpeg,.png maksimal 10MB",
        colwidth: "5",
        flexStart: true
      },
      {
        label: "Hasil Iol Master",
        type: "file",
        placeholder: "Upload Hasil Iol Master",
        name: "foto_iol_master[0]",
        value: '',
        mandatory: true,
        additional: "File berekstensi .pdf,.zip,.jpg,.png maksimal 10MB",
        colwidth: "5",
        flexStart: true
      }
    ]
  },
  {
    colnum: 2,
    flexStart: true,
    columns: [
      {
        label: "Upload Foto Fundus",
        type: "image",
        placeholder: "",
        name: "foto_fundus",value: "",
        mandatory: false,
        optional: true,
        additional: "File berekstensi .jpg,.jpeg,.png maksimal 10MB",
        colwidth: "5",
        flexStart: true
      },
      {
        label: "SOAP",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "soap",
        value: "",
        mandatory: false,
        optional: true,
        additional: "",
        colwidth: "5",
        rows: 8,
        flexStart: true
      }
    ]
  }
];
